import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-power-by-tabit',
    templateUrl: './power-by-tabit.component.html',
    styleUrls: ['./power-by-tabit.component.scss'],
    standalone: false
})
export class PowerByTabitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
